import React from 'react';
export function Guarantee() {
  return <section className="bg-white py-10" data-id="element-97" data-mp="7pf4bqpn0hze">
      <div className="mx-auto max-w-2xl px-6 text-center sm:px-8" data-id="element-98" data-mp="20ld41agynxig">
        <h3 className="font-heading text-2xl font-bold text-marino" data-id="element-99" data-mp="20jil21p92fh0">🛡️ Garantía de Satisfacción de 14 Días</h3>
        <p className="mt-3 text-[15px] leading-relaxed text-gris-texto" data-id="element-100" data-mp="24ldmr7b3euvb">
          Si el producto no cumple con lo prometido, escríbenos a{' '}
          <a href="mailto:manualeslistos@gmail.com" className="font-medium text-azul underline" data-id="element-101" data-mp="2ebygohftnb7w">
            manualeslistos@gmail.com
          </a>{' '}
          y te ayudaremos a resolverlo en menos de 24 horas.
        </p>
        <p className="mt-4 text-sm font-semibold text-azul" data-id="element-102" data-mp="2obz2ca15y3f9">
          Más de 9.000 entrenadores ya lo usan. Nuestra tasa de devolución es menor al 1%.
        </p>
      </div>
    </section>;
}